window.addEventListener('DOMContentLoaded', () => {

  if ( $('.cart-upsell-slideshow--drawer') ) {
    const slides = $('.cart-upsell-slide').length
    if ( slides > 1 ) {
      $('.cart-upsell-slideshow--drawer').slick({
        infinite: true,
        arrows: true,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 1
      });
    }

    const $div = $("#CartDrawer");
    const observer = new MutationObserver(function(mutations) {
      mutations.every(mutation =>  {
        // console.log(mutation)
        if ( mutation.target.classList.contains('drawer--is-open') ) {
          $('.cart-upsell-slideshow--drawer').slick('refresh');
          return false;
        }
      })
    });

    observer.observe($div[0], {
      attributes: true,
      attributeFilter: ['class']
    });
  }
});